import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../store';
import { SubmitIntention } from '../../frameworks_drivers/redux/types/SubmitIntention';

export const usePreferredSubmitIntention = () => {
  const dispatch = useDispatch();
  const preferredSubmitIntention = useSelector(
    (state: RootState) => state.misc.preferredSubmitIntention
  );

  const setPreferredSubmitIntention = (intention: SubmitIntention) => {
    dispatch({ type: 'miscellaneous/setPreferredSubmitIntention', payload: intention });
  };

  const togglePreferredSubmitIntention = () => {
    switch (preferredSubmitIntention) {
      case 'offer':
        setPreferredSubmitIntention('order');
        break;
      case 'order':
        setPreferredSubmitIntention('offer');
        break;
      default:
        setPreferredSubmitIntention('order');
    }
  };

  return { preferredSubmitIntention, setPreferredSubmitIntention, togglePreferredSubmitIntention };
};
